export default "__VITE_ASSET__BYhP4pTV__"